package com.flowyride.core.api

import kotlinx.serialization.Serializable

/** Round trips generated by the server (several engine calls: rate limited on their own). */
object LoopsApi {
    /** POST [LoopRequestDto] → 200 [LoopResponseDto], or an error status with [ApiErrorDto]. */
    const val PATH = "/api/loops"
}

@Serializable
enum class CompassDirectionDto { N, NE, E, SE, S, SW, W, NW }

/** Exactly one of [distanceMeters] and [durationSeconds] is set. [direction] null = any. */
@Serializable
data class LoopRequestDto(
    val start: GeoPointDto,
    val distanceMeters: Double? = null,
    val durationSeconds: Double? = null,
    val direction: CompassDirectionDto? = null,
    val preferences: RoutePreferencesDto,
    val seed: Int,
)

@Serializable
data class LoopResponseDto(
    val waypoints: List<GeoPointDto>,
    val route: RouteResponseDto,
)
